import React from "react";
import bulb from "../assets/icons/bulb.svg";
import GuidanceSections from "./GuidanceSections";

const TipsModal = ({
  show,
  onClose,
  tipText,
}: {
  show: boolean;
  onClose: () => void;
  tipText: string;
}) => {
  if (!show) return null;
  if (!tipText) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-lg p-6 w-full max-w-[28rem] max-h-[85vh] flex flex-col relative">
        <button
          className="absolute top-2 right-3 text-xl font-bold text-[#1F2937] text-[32px]"
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>

        <div className="flex items-center mb-4">
          <span className="text-orange-500 mr-2 text-md">
            <img src={bulb} alt="bulb" className="w-6 h-6" />
          </span>
          <h3 className="text-[28px] font-medium text-[#1e2b5e] font-georgia leading-[32px] tracking-[0px] vertical-align-middle">
            Tips
          </h3>
        </div>

        {/* Long tips scroll rather than pushing Close off the screen. */}
        <div className="overflow-y-auto mb-2">
          <GuidanceSections text={tipText} />
        </div>

        <button
          className="w-full bg-[#F4A261] text-[#1B365D] font-semibold p-3 rounded-[50px] text-base hover:bg-[#F29449] mt-2 flex-none"
          onClick={onClose}
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default TipsModal;
